export default "__VITE_ASSET__DDDIz4bu__"